///Saga Effects
import { all, call } from "redux-saga/effects";
////Sagas
import documentsSaga from "./Documents/documents.saga";
import accountUsersSaga from "./UsersAccount/userAccount.saga";
import rolesSaga from "./Roles/roles.saga";
import interfaceSaga from "./InterfaceApi/interfaceApi.saga";
import profileSaga from "./Profile/profile.saga";
import templateSaga from "./Templetes/template.saga";
//Default
export default function* rootSaga() {
  yield all([call(documentsSaga), call(accountUsersSaga) , call(rolesSaga) , call(interfaceSaga), call(profileSaga), call(templateSaga)]);
}
